import React from 'react'
import { useSelector } from 'react-redux'
import AddressForm from '../address-form'
import HotSwapSummary from '../how-swap-summary'
import { makeStyles } from '@material-ui/core/styles'
import CustomCheckbox from 'web/src/app/root/components/common/checkbox'

const useStyles = makeStyles(() => {
    return {
        container: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '75px'
        },
        cbHotSwap: {
            display: 'flex',
            marginTop: 19
        },
        cbHotSwapChecker: {
            margin: '0'
        },
        regularText: {
            fontSize: 14,
            fontWeight: 500
        },
        thinText: {
            fontSize: 14,
            fontWeight: 300
        }
    }
})

export default function AddressShippingStep({
    selectedHotSwapLocations,
    formRef,
    setFormData
}) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    return (
        <div className={classes.container}>
            <HotSwapSummary
                selectedHotSwapLocations={selectedHotSwapLocations}
            />
            <div>
                <AddressForm ref={formRef} setFormData={setFormData} />
                <div className={classes.cbHotSwap}>
                    <CustomCheckbox
                        onClick={() => console.log('Clicked.')}
                        className={classes.cbHotSwapChecker}
                    />
                    <div>
                        <div className={classes.regularText}>
                            {locale.hotSwap.rememberAddress}
                        </div>
                        <div className={classes.thinText}>
                            {locale.hotSwap.saveAddress}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
